import React from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const OTPSettingsSkeleton = () => {
  return (
    <Form>
      <Row>
        <Col>
          <Form.Group controlId="allowUnlockDisabledLogin" className="mb-4">
            <div className="form-check d-flex">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label mr-3'}
              />
              <Skeleton
                count={1}
                width={190}
                containerClassName={'form-label'}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="passwordMinLength" className="mb-4">
            <Form.Label for="MinLength" className="m-0">
              <Skeleton
                count={1}
                width={195}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="passwordMinLength" className="mb-4">
            <Form.Label for="MinLength" className="m-0">
              <Skeleton
                count={1}
                width={195}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="passwordMinLength" className="mb-4">
            <Form.Label for="MinLength" className="m-0">
              <Skeleton
                count={1}
                width={195}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="passwordMinLength" className="mb-4">
            <Form.Label for="MinLength" className="m-0">
              <Skeleton
                count={1}
                width={165}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group controlId="passwordMaxLength" className="mb-4">
            <Form.Label for="MaxLength" className="m-0">
              <Skeleton
                count={1}
                width={165}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default OTPSettingsSkeleton;
